import { csvToObj } from 'csv-to-js-parser';
import dayjs from 'dayjs';

import { ProjectVenue } from '@/domain/project-venue/entities/project-venue.entity';
import { VenueDateBasic } from '@/domain/project-venue-dates/entities/project-venue-dates.entity';

interface IProps {
  project: ProjectVenue;
  setCreationResult: React.Dispatch<
    React.SetStateAction<{
      dates: VenueDateBasic[];
      datesCreated: number;
      datesNotCreated: number;
    }>
  >;
  file: File;
}

export function formatImportedDates({
  project,
  setCreationResult,
  file,
}: IProps): Promise<void> {
  return new Promise((resolve) => {
    const reader = new FileReader();
    reader.readAsText(file);
    let datesCreated = 0;
    let datesNotCreated = 0;
    const newDates: { name: string; date: string }[] = [];

    reader.onload = () => {
      const result = reader.result as string;
      const data: {
        Date: string;
        'Nom de l’évènement': string;
        Configuration: string;
      }[] = csvToObj(result);

      data.forEach((row, index) => {
        if (row.Date && row['Nom de l’évènement']) {
          const format = ['DD/MM/YYYY', 'DD/MM/YY'];
          const formattedDate = dayjs(row.Date, format);
          if (!formattedDate.isValid()) {
            console.warn(`invalid date ${row.Date}`);
          }
          if (
            formattedDate.isValid() &&
            formattedDate.isSameOrAfter(dayjs(project.startDate)) &&
            formattedDate.isSameOrBefore(dayjs(project.endDate))
          ) {
            newDates.push({
              name: row['Nom de l’évènement'],
              date: formattedDate.toISOString(),
            });
            datesCreated++;
          } else {
            datesNotCreated++;
          }
        } else datesNotCreated++;

        setCreationResult({ datesCreated, datesNotCreated, dates: newDates });
        if (data.length === index + 1) resolve();
      });
    };
  });
}
